import { logger } from '../scripts/logger';

export default logger;
